@if(loading$ | async) {
<div class="loading">
  <div class="card flex justify-center progress-spinner">
    <p-progress-spinner
      strokeWidth="5"
      fill="transparent"
      animationDuration="1s"
      [style]="{ width: '120px', height: '120px' }"
    />
  </div>
</div>
}
<p-toast position="top-right"></p-toast>
<router-outlet></router-outlet>
